import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection } from '@iotv/iotv-v3-types';

const typeName = 'IrrigationZone';

export type IrrigationZoneProps = {
  name?: string;
  created_at?: number;

  updated_at?: number;
};

export class IrrigationZone extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  created_at?: number;
  updated_at?: number;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of the Zone eg south field' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Space for comments ' },
    };
  };
}
